import { render, staticRenderFns } from "./CouponsManager.vue?vue&type=template&id=39ec1595&scoped=true"
import script from "./CouponsManager.vue?vue&type=script&lang=js"
export * from "./CouponsManager.vue?vue&type=script&lang=js"
import style0 from "./CouponsManager.vue?vue&type=style&index=0&id=39ec1595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec1595",
  null
  
)

export default component.exports